/**
 * @ngdoc Controller
 * @name AdminDevicesController
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('AdminDevicesController', AdminDevicesController);

    /**
 * @constructor
     * @ngInject
 */
    function AdminDevicesController($timeout, $log, $location, $scope, AdminTableService, GraphService, ApiService) {
        $log.info('AdminDevicesController');
        $scope.searchModel = { value: $location.search().q || '' };
        $scope.abortController = null;
        $scope.signal = null;

        $scope.isSearchValueValid = () =>{
            const val = $scope.searchModel.value;
            //Serial number max length is 11 characters
            return val && val != "" && val.length >= 3 && val.length <= 11 && onlyLettersAndNumbers(val);
        }

        $scope.abortPrevious = () =>{
            // abort and create a new abortController
            $scope.table.state.isPressed = false;
            $scope.table.state.total = 0;
            if($scope.table.state.isLoading){
                $scope.table.state.isLoading = false;
                $scope.table.state.isCancelled = true; // should be only if request was ongoing
            }
            if(!$scope.abortController){
                $scope.abortController = new AbortController();
                $scope.signal = $scope.abortController.signal;
             }
            else{
                $scope.abortController.abort(); // abort previous signal
                $scope.table.state.isLoading
                $scope.abortController = new AbortController();
                $scope.signal = $scope.abortController.signal;
            }
        }

        function onlyLettersAndNumbers(str) {
            return /^[A-Za-z0-9]*$/.test(str);
        }

        var endPoint = function (params, signal) {
            const queryObj = params;
            queryObj.q = $scope.searchModel.value;
            return ApiService.adminWithAbort(signal,"devices?", queryObj);
        };

        $scope.table = new AdminTableService(endPoint, $scope);
        $scope.searchTimeout = null;

        $scope.search = async function () {
            $scope.table.state.isCancelled = false;
            $scope.table.state.isPressed = true;
            if($scope.table.state.isLoading) return;
            if ($scope.isSearchValueValid()) {
                $scope.table.params.reload().then(
                    ()=>{},
                    ()=>{$scope.table.state.isLoading = false}
                );
            }
        }

    }
})();
